import { render, staticRenderFns } from "./SheetSettingConfig.vue?vue&type=template&id=224dac8f"
import script from "./SheetSettingConfig.vue?vue&type=script&lang=js"
export * from "./SheetSettingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224dac8f')) {
      api.createRecord('224dac8f', component.options)
    } else {
      api.reload('224dac8f', component.options)
    }
    module.hot.accept("./SheetSettingConfig.vue?vue&type=template&id=224dac8f", function () {
      api.rerender('224dac8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/occurrence/SheetSettingConfig.vue"
export default component.exports